//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2ClientUpdate', {
//        templateUrl: 'views/components/views/p2ClientUpdate/p2ClientUpdate.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['p2ClientUpdateService', function (p2ClientUpdateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListClientUpdates: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadClientUpdates() {
//                vm.model.itemsListClientUpdates = await p2ClientUpdateService.listClientUpdates();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadClientUpdates();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
